import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Amount from "@smpu-web/nested/form/amount"
import Element from "@bappweb/element"
import { numeric, RegexpTypes, required, dateFormat, minValue, minLength, maxLength } from "@bappweb/utils"
import { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation } from "../../../api/services"
import { getDayMonthYearFromStr } from "../../../../../utils/utils"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import "../../assets/style.scss"
import Block from "@bappweb/block"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Col from "@bappweb/col"
import { UiInfo } from "@bappweb/icon"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { useAppSelector, useAppDispatch } from "../../../config/hook"
import { setIsfocusInput } from "src/projects/kredi-karti/state/focusInput"
import { setSessionData } from "src/projects/kredi-karti/state/sessionData"

type PropsType = {
  onError?: (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => void
  onSubmit?: (event?: React.BaseSyntheticEvent, values?: Record<string, any>) => void
}

function MainForm({ onError, onSubmit }: PropsType) {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const isFocusInput = useAppSelector((state) => state.focusInput.response?.isFocusInput)
  const sessionData = useAppSelector((state) => state.sessionData.response)
  const inputRef = useRef<HTMLInputElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null);

  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isHigherThanMd = size > Sizes.md ? true : false

  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [identityNumber, setIdentityNumber] = useState('')
  const [mobilePhone, setMobilePhone] = useState('')
  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string>()
  const [isFetching, setIsFetching] = useState(false)

  const [getCaptcha] = useGetCaptchaMutation();
  const [getTokenByTckn1] = useGetTokenByTckn1Mutation();

  const handleSetTokenSessionId = (value: any) => {
    setCaptchaValues({
      ...captchaValues,
      tokenSessionId: "",
      captchaData: "",
      showCaptcha: false
    })
    if (value.length === 11) {
      setIsFetching(true)
      getTokenByTckn1(value)
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setError('')
            setCaptchaValues({
              ...captchaValues,
              tokenSessionId: payload.tokenSessionId,
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => { setIsFetching(false) })
    }
  }

  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        tckn: identityNumber,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setError('')
            setCaptchaValues({
              ...captchaValues,
              showCaptcha: true,
              captchaData: payload.captchaData,
              captchaValidate: true
            })
          }
          else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => { setIsFetching(false) })
    }
  }, [captchaValues, getCaptcha, identityNumber])

  useEffect(() => {
    if (isFocusInput && inputRef.current) {
      inputRef.current.focus()

      dispatch(
        setIsfocusInput({
          isFocusInput: false
        })
      )
    }
  }, [isFocusInput])


  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    switch (name) {
      case "identityNumber":
        setIdentityNumber(value)
        handleSetTokenSessionId(value)
        break;
      case "captcha":
        setCaptchaValues({
          ...captchaValues,
          captcha: value,
          captchaValidate: true
        })
        break;
      default:
        break;
    }
  }, [getTokenByTckn1, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation();
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tckn: identityNumber,
      TokenSessionId: captchaValues.tokenSessionId,
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setError('')
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => { setIsFetching(false) })
  }, [refreshCaptcha, identityNumber, captchaValues])

  const [apply] = useApplyMutation()

  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && values.identityNumber && values.birthdate && values.mobilePhone && values.captcha && values.checkboxKvkk) {
        setIsFetching(true)
        const parsedBirthDate = getDayMonthYearFromStr(values.birthdate)

        apply({
          tckn: values.identityNumber,
          dogumYil: parsedBirthDate.year,
          dogumAy: parsedBirthDate.month,
          dogumGun: parsedBirthDate.day,
          cepTel: "0090" + values.mobilePhone.replace(/\s/g, ''),
          captcha: values.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          cid: sessionData?.cid ?? "",
          TokenSessionId: captchaValues.tokenSessionId,
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError('')
              history.push({
                pathname: "/details/smsotp",
                state: payload
              })
            } else {         
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0,
              });
              refreshCaptcha({
                tckn: identityNumber,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  }
                  else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => { setIsFetching(false) })
            }
          })
          .finally(() => { setIsFetching(false) })
      }
      if (onSubmit) {
        onSubmit(e, values)
      }
    },
    [history, onSubmit, apply, captchaValues, identityNumber, refreshCaptcha]
  )

  const handleError = useCallback(
    (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => {
      //TODO:
      if (onError) {
        onError(event, errorField)
      }
    },
    [onError]
  )

  const handleClickBottomButton = () => {
    document.getElementById('identityNumber')?.focus();
    dispatch(
      setIsfocusInput({
        isFocusInput: true
      })
    )
  }

  //sayfa scroll olduktan sonra "Hemen Basvur" butonu gozukmuyorsa sticky "hemen basvur" butonunu gosteren useeffect
  useEffect(() => {
    const handleScroll = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        setIsButtonVisible(isVisible);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  //sayfa ilk acildiginda "Hemen Basvur" butonu gozukmuyorsa sticky "hemen basvur" butonunu gosteren useeffect
  useEffect(() => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      setIsButtonVisible(isVisible);
    }
  }, []);

  return (
    <Block type="main">
      <Block type="section" className="section-form-scrollTo">
        <Block className="container container-mobile">
          <Block className="box">
            <Form id="form1" onError={handleError} onSubmit={handleSubmit} onChange={handleChange} grid={false}>
              <Block className="input-block error">
                <FormMessage className={"error form-msg-error"} error={error}></FormMessage>
              </Block>
              <Element type="h2" className="landing-form-h2">
                1 Dakikada Başvurun, Ticari Kredi Kartınız Hemen Adresinize Gelsin!
              </Element>
              <Grid>
                <Row>
                  <Col xs={12} md={12} lg={6} xl={6} mdOffset={1} lgOffset={1} xlOffset={1} className="text-field-grid">
                    <TextField
                      label='TC Kimlik No'
                      type="number"
                      inputMode="numeric"
                      maxLength={11}
                      value={identityNumber}
                      validator={RegexpTypes.Numeric}
                      validations={[required("Zorunlu Alan"), numeric(), minLength(11, "TC kimlik numaranızı eksik veya yanlış girdiniz"), maxLength(11, "TC kimlik numaranızı eksik veya yanlış girdiniz")]}
                      className="tckn only-number required focussedInput"
                      name="identityNumber"
                      id="identityNumber"
                      ref={inputRef}
                    />
                  </Col>
                  <Col xs={12} md={12} lg={6} xl={6} mdOffset={1} lgOffset={1} xlOffset={1} className="text-field-grid">
                    <Element type="span" className="text-input-wrapper after-error">
                      <TextField
                        label='Doğum Tarihi'
                        type="text"
                        inputMode="numeric"
                        className="dateformat required"
                        name="birthdate"
                        id="birthdate"
                        placeholder="GG.AA.YYYY"
                        mask="99.99.9999"
                        maxLength={10}
                        validations={[
                          required("Zorunlu Alan"),
                          dateFormat("Lütfen Geçerli Bir Tarih Giriniz")
                        ]}
                      />
                    </Element>
                  </Col>
                </Row>
              </Grid>
              <Grid>
                <Row>
                  <Col xs={12} md={12} lg={6} xl={6} mdOffset={2} lgOffset={1} xlOffset={1} className="text-field-grid">
                    <Element type="span" className="text-input-wrapper after-error">
                      <TextField
                        label='Cep Telefonu'
                        type="text"
                        inputMode="numeric"
                        className="phone required"
                        value={mobilePhone}
                        placeholder="5__ ___ __ __"
                        mask="999 999 99 99"
                        name="mobilePhone"
                        maxLength={13}
                        validations={[required("Zorunlu Alan")]}
                      />
                    </Element>
                  </Col>
                  <Col xs={12} md={12} lg={6} xl={6} mdOffset={2} lgOffset={1} xlOffset={1} className="text-field-grid">
                    {captchaValues.showCaptcha && (
                      <Captcha
                        label="Güvenlik Kodu"
                        id="captcha"
                        type="text"
                        name="captcha"
                        placeholder="Güvenlik Kodu"
                        captcha={captchaValues.captchaData}
                        value={captchaValues.captcha}
                        captchaValidate={captchaValues.captchaValidate}
                        maxLength={4}
                        maxRefreshCount={3}
                        refreshClick={handleCaptchaRefresh}
                        validations={[required("Zorunlu Alan")]}
                      />
                    )}
                  </Col>
                </Row>
              </Grid>
              <Grid>
                <Row>
                  {isHigherThanMd && <Col xs={12} md={12} lg={6} xl={6} mdOffset={1} lgOffset={1} xlOffset={1} className="text-field-grid grid-button">
                    <Block className="checkboxKvkk-container">
                      <Checkbox
                        name="checkboxKvkk"
                        validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                        className="cb-position-fix"
                        validateOnSubmit={true}
                        block
                      >
                        <Link
                          href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                          text={"Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme"}
                          inline
                          target="_blank"
                        />
                        {"’yi okudum."}
                      </Checkbox>
                    </Block>
                  </Col>}
                  {isHigherThanMd && <Col xs={12} md={12} lg={6} xl={6} mdOffset={1} lgOffset={1} xlOffset={1} className="text-field-grid grid-button">
                    <Button
                      text="Hemen Başvur" type="submit" className="landing-form-button btn btn-primary w-100 mt-label btn-submit" fetching={isFetching} disabled={isFetching}
                      ref={buttonRef}
                      onClick={() =>
                        setCaptchaValues({
                          ...captchaValues,
                          captchaValidate: true
                        })
                      } />
                  </Col>}
                </Row>
              </Grid>
              {!isHigherThanMd &&
                <Grid>
                  <Row>
                    <Block className="checkboxKvkk-container">
                      <Checkbox
                        name="checkboxKvkk"
                        validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                        className="cb-position-fix"
                        validateOnSubmit={true}
                        block
                      >
                        <Link
                          href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                          text={"Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme"}
                          inline
                          target="_blank"
                        />
                        {"’yi okudum."}
                      </Checkbox>
                    </Block>
                  </Row>
                </Grid>
              }
              <Block className="d-flex">
                <UiInfo
                  size={32}
                  className="landing-ui-info"
                />
                <Element type="p" >
                  Kart başvurunuzun tamamlanmaması durumunda, işleminizin tamamlanması için Akbank Telefon Şubesi
                  sizinle iletişime geçebilecektir.
                </Element>
              </Block>
              <Block className="d-flex d-flex-second">
                <UiInfo
                  size={32}
                  className="landing-ui-info"
                />
                <Element type="p" >
                  Kampanya detaylarını aşağıda görebilirsiniz.
                </Element>
              </Block>
              {!isHigherThanMd &&
                <Grid>
                  <Row>
                    <Col xs={12} md={12} lg={4} xl={4} mdOffset={1} lgOffset={1} xlOffset={1} className="text-field-grid grid-button">
                      <Button
                        text="Hemen Başvur" type="submit" className="btn btn-primary w-100 mt-label btn-submit" fetching={isFetching} disabled={isFetching}
                        ref={buttonRef}
                        onClick={() =>
                          setCaptchaValues({
                            ...captchaValues,
                            captchaValidate: true
                          })
                        } />
                    </Col>
                  </Row>
                </Grid>
              }
            </Form>
          </Block>
        </Block>
      </Block >
      {/* Alt kisimdaki "Hemen Basvur" sticky butonu*/}
      {
        !isHigherThanMd && !isButtonVisible && !sessionData?.isStickyActive &&
        <Block className="bottom-sticky" onClick={handleClickBottomButton}>
          <Element className="bottom-sticky-text">
            Hemen Başvur
          </Element>
        </Block>
      }
    </Block >
  )
}

export default MainForm
